import { render } from "./MonitoringTabs.vue?vue&type=template&id=60ed9372&ts=true"
import script from "./MonitoringTabs.vue?vue&type=script&lang=ts"
export * from "./MonitoringTabs.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__